import { FitText } from "./FitText";
import { positionLabel } from "../../lib/shield";

const COND = "'Barlow Condensed', sans-serif";
const DISPLAY = "'Outfit', sans-serif";

export const RatingLayer = ({ player, color, accent, filter }) => (
  <g data-layer="rating" fill={color} filter={filter}>
    <FitText testId="shield-rating" text={player.rating === "" ? "–" : player.rating} x={74} y={160} base={64} maxW={74} min={40}
      fontFamily={DISPLAY} fontWeight="900" opacity={player.rating === "" ? 0.6 : 1} />
    <FitText testId="shield-position" text={positionLabel(player) || "–"} x={74} y={192} base={26} maxW={84} min={14}
      fontFamily={COND} fontWeight="700" letterSpacing="1" />
    <rect x="50" y="202" width="48" height="2.5" fill={accent} />
  </g>
);

export const NameLayer = ({ player, color, accent, filter, number }) => (
  <g data-layer="name" filter={filter}>
    <FitText testId="shield-name" {...number} text={(player.name || "Your name").toUpperCase()} x={200} y={458} base={52} maxW={318} min={22}
      fontFamily={COND} fontWeight="800" letterSpacing="1" fill={color} opacity={player.name ? 1 : 0.55} />
    <rect x="70" y="470" width="260" height="2.5" fill={accent} />
  </g>
);

const StatRow = ({ stat, value, valueX, y, color }) => (
  <g data-testid={`shield-stat-${stat.key}`}>
    <text x={valueX} y={y} textAnchor="end" fontFamily={COND} fontWeight="800" fontSize="30" fill={color}
      opacity={value === "" ? 0.6 : 1} data-testid={`shield-stat-${stat.key}-value`}>{value === "" ? "–" : value}</text>
    <text x={valueX + 7} y={y} fontFamily={COND} fontWeight="600" fontSize="24" fill={color} letterSpacing=".5">{stat.key}</text>
  </g>
);

export const StatsLayer = ({ stats, defs, color, accent, filter }) => (
  <g data-layer="stats" filter={filter}>
    {defs.map((s, i) => (
      <StatRow key={s.key} stat={s} value={stats[s.key]} valueX={i < 3 ? 142 : 262} y={502 + (i % 3) * 30} color={color} />
    ))}
    <rect x="199" y="482" width="2" height="86" fill={accent} opacity=".8" />
  </g>
);

export const ClubNameLayer = ({ name, color, filter }) =>
  name ? (
    <g data-layer="club-name" filter={filter}>
      <FitText testId="shield-club-name" text={name.toUpperCase()} x={200} y={412} base={15} maxW={240} min={9}
        fontFamily={COND} fontWeight="700" letterSpacing="2" fill={color} opacity=".85" />
    </g>
  ) : null;
